import { filter } from '@prismicio/client';
import BlogCard from './BlogCard';
import { createClient } from '@/prismicio';
import { blogCardQuery } from './constants';
import { BlogDocument } from '../../../prismicio-types';

interface Props {
  variation?: 'default' | 'with_author' | 'new-simple';
  readBlog?: string; // UID or ID
  blogsCount?: number;
}

export const Related = async ({
  readBlog,
  variation = 'default',
  blogsCount = 3,
}: Readonly<Props>) => {
  if (!readBlog) return null;

  const client = createClient({
    fetchOptions: {
      next: { tags: ['related_blogs'] },
      cache: 'force-cache',
    },
  });

  let blogs: BlogDocument[] = [];

  const normalized = readBlog.trim().toLowerCase();

  // CASE A: Search by Author
  if (normalized === 'devsu') {
    const { results } = await client.getByType('blog', {
      pageSize: blogsCount,
      filters: [filter.fulltext('my.blog.author', 'Devsu')],
      graphQuery: blogCardQuery,
    });
    blogs = results;
  } else {
    // CASE B: Search by similar post or detected UID
    let blogId = readBlog;
    if (readBlog.length < 36) {
      const blogDoc = await client.getByUID('blog', readBlog);
      if (!blogDoc) return null;
      blogId = blogDoc.id;
    }

    const { results } = await client.getByType('blog', {
      pageSize: blogsCount,
      filters: [filter.similar(blogId, 3)],
      graphQuery: blogCardQuery,
    });

    blogs = results;
  }

  // CASE C: fallback just show featured post
  if (!blogs || blogs.length === 0) {
    const { results: featured } = await client.getByType('blog', {
      pageSize: blogsCount,
      filters: [filter.at('my.blog.featured', true)],
      orderings: [
        { field: 'document.last_publication_date', direction: 'desc' },
      ],
      graphQuery: blogCardQuery,
    });
    blogs = featured;
  }

  if (!blogs || blogs.length === 0) return null;

  return (
    <div className="w-full max-w-screen-2xl mx-auto px-5 md:px-16 py-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
        {blogs.map(({ data, uid, last_publication_date }) => (
          <BlogCard
            key={`related_post_${uid}`}
            {...data}
            cardType={variation === 'default' ? 'simple' : variation}
            uid={uid}
            containerClass="w-full"
            date={last_publication_date}
          />
        ))}
      </div>
    </div>
  );
};
